export const USER_ENDPOINTS = {
  fetchUser: '/api/access/Users/Me',
  fetchUserV2: '/api/access/v2/Users/Me',
  fetchUsers: '/api/access/v2/Users',
};
